import { Card } from "semantic-ui-react";

interface BOMCardProps {
  icon: string;
  title: string;
  isActive: boolean;
  onClick: () => void;
  testId?: string;
}

const BOMCard = ({ icon, title, isActive, onClick, testId }: BOMCardProps) => (
  <Card className={`bom-card ${isActive ? "active" : ""}`} onClick={onClick} data-testid={testId}>
    <Card.Content>
      <div className="card-icon-wrapper">
        <img src={icon} alt={title} className="card-icon" />
      </div>
      <Card.Header className="card-title">{title}</Card.Header>
    </Card.Content>
  </Card>
);

export default BOMCard;
